import { FC } from 'react';

import { Divider, StyleProps } from '@bonusly/design-system';

export const NavDivider: FC<StyleProps> = (props) => <Divider borderColor="border.soft" my={1} {...props} />;
